import React, { useEffect, useRef, useState } from 'react';

/**
 * lot DK2 — barre de sections de la fiche contact complète.
 * Même style que les onglets de la fiche contact (h-12, soulignement bleu de la section active).
 * La section active suit le défilement ; le décalage utilise la hauteur réelle de ce qui est collé.
 */
const NavigationBar = ({ sections }) => {
  const [active, setActive] = useState(sections[0]?.id);
  const barre = useRef(null);

  const decalage = () => {
    const rect = barre.current?.getBoundingClientRect();
    return rect ? rect.bottom + 8 : 120;
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) return;
    const conteneur = document.querySelector('.overflow-auto');
    if (conteneur) {
      const haut = element.getBoundingClientRect().top - conteneur.getBoundingClientRect().top;
      conteneur.scrollTo({ top: Math.max(0, haut + conteneur.scrollTop - decalage()), behavior: 'smooth' });
    } else {
      window.scrollTo({ top: Math.max(0, element.getBoundingClientRect().top + window.scrollY - decalage()), behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const conteneur = document.querySelector('.overflow-auto');
    const suivre = () => {
      const limite = decalage() + 8;
      let courante = sections[0]?.id;
      sections.forEach((s) => {
        const el = document.getElementById(s.id);
        if (el && el.getBoundingClientRect().top <= limite) courante = s.id;
      });
      setActive(courante);
    };
    suivre();
    const cible = conteneur || window;
    cible.addEventListener('scroll', suivre, { passive: true });
    return () => cible.removeEventListener('scroll', suivre);
  }, [sections]);

  // lot DK3 — une seule section : pas de barre
  if (sections.length < 2) return null;

  return (
    <div ref={barre} className="bg-white border-b border-slate-200" data-testid="contact-form-sections">
      <div className="flex items-center overflow-x-auto scrollbar-hide">
        {sections.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => scrollToSection(s.id)}
            data-testid={`contact-form-section-${s.id}`}
            className={`flex-1 min-w-[88px] h-12 px-3 text-sm font-semibold border-b-2 whitespace-nowrap transition ${
              active === s.id ? 'border-blue-600 text-blue-700' : 'border-transparent text-slate-500'
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavigationBar;
